<ul *ngIf="hasErrors()">
  <li *ngFor="let error of allErrors">
    {{error.message | translate: error.params}}
  </li>
</ul>
